import { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import WidgetContainer from '../components/WidgetContainer';
import SendIcon from '@mui/icons-material/Send';
import PushMessageWidgetBody from '../components/PushMessageWidgetBody';
import adminService from '../data/AdminService';

const AdminPage = () => {
   const [pushMessages, setPushMessages] = useState({ loading: false });

   const handleSendPushMessage = async (backgroundPushMessage) => {
      setPushMessages({ loading: true });
      await adminService.postBackgroundPushMessage({
         ...backgroundPushMessage,
         userIds: backgroundPushMessage.userIds.split(';'),
      });
      setPushMessages({ loading: false });
   };

   return (
      <div>
         <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
               <Grid item xs={12}>
                  <WidgetContainer
                     title="Send Background Push Message"
                     icon={SendIcon}
                     color="#00a5de"
                  >
                     <PushMessageWidgetBody
                        loading={pushMessages.loading}
                        onSendPushMessage={handleSendPushMessage}
                     />
                  </WidgetContainer>
               </Grid>
            </Grid>
         </Box>
      </div>
   );
};

export default AdminPage;
